import React from 'react';
import AuthService from '../services/AuthService';

export default function LoggedOut(props) {
    const signInAsync = async (e) => {
        var authService = await AuthService.getInstance();
        try {
            await authService.signinRedirect();
        }
        catch(err){
            console.error('Error logging in', err);
            alert('Error logging in');
        }
    }

    return (
        <div>
            Thanks, you are now logged out. Please close this window or&nbsp;
            <span className="btn-link" onClick={signInAsync}>click here to log back in</span>.
        </div>
    );
}